import { render, staticRenderFns } from "./PrescriptionsForm.vue?vue&type=template&id=78c7ca17"
import script from "./PrescriptionsForm.vue?vue&type=script&lang=js"
export * from "./PrescriptionsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports